import i18next from "i18next";

import { createColumn } from "../../../../components/Table";

export const desktopTableColumns = [
  createColumn({
    keyName: "type",
    header: () => i18next.t("patientPage_columns_type"),
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "trigger",
    header: () => i18next.t("patientPage_columns_trigger"),
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "timeFrame",
    header: () => i18next.t("patientPage_columns_time_frame"),
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "value",
    header: () => i18next.t("patientPage_columns_value"),
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "timeOfAlert",
    header: () => i18next.t("patientPage_columns_time_of_alert"),
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "alertStatus",
    header: () => i18next.t("patientPage_columns_alert_status"),
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "resolvedBy",
    header: () => i18next.t("patientPage_columns_resolved_by"),
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "summary",
    header: () => i18next.t("patientPage_columns_alert_summary"),
    cell: (info) => info.renderValue(),
    size: 30,
  }),
  createColumn({
    keyName: "action",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 30,
  }),
];
